export const followUpsStages = [
  {
    value: "NO UPDATE",
    label: "No update",
  },
  {
    value: "FOLLOW UPS",
    label: "Follow up",
   
  },{
    value: "FOLLOWED BACK",
    label: "Followed back",
  }
];
